import React from 'react'
import PropTypes from 'prop-types'
import { cn } from 'shared/util/cn'

function Loader({ className = '' }) {
  return (
    <div
      className={cn(
        'block h-6 w-6 animate-spin rounded-full border-[3px] border-solid border-theme border-r-transparent',
        className
      )}
      role="status"
      aria-label="Loading"
    />
  )
}

Loader.propTypes = {
  className: PropTypes.string
}

export default React.memo(Loader)
